// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pelipper: PokeData = {
  "id": 279,
  "name": "pelipper",
  "height": 12,
  "weight": 280,
  "base_experience": 154,
  "types": [
    PokeType.WATER,
    PokeType.FLYING
  ],
  "api_moves": [
    "wing-attack",
    "growl",
    "supersonic",
    "mist",
    "water-gun",
    "hydro-pump",
    "agility",
    "quick-attack",
    "protect",
    "stockpile",
    "spit-up",
    "swallow",
    "water-sport",
    "water-pulse",
    "roost",
    "brine",
    "tailwind",
    "payback",
    "fling",
    "air-slash",
    "soak",
    "hurricane"
  ],
  "moves": [
    "growl",
    "supersonic",
    "hydro-pump",
    "quick-attack",
    "protect",
    "roost",
    "brine",
    "tailwind",
    "air-slash",
    "hurricane",
    "liquidation",
    "aqua-cutter",
    "chatter"
  ],
  "evolution_chain": {
    "id": 139,
    "item": null,
    "species": [
      {
        "name": "wingull",
        "order": 303,
        "types": [
          PokeType.WATER,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "pelipper",
        "order": 304,
        "types": [
          PokeType.WATER,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 278,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 125,
    "speed": 112,
    "ability_power": 163
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
